import numeral from "numeral";
import React, { Component } from "react";
import icon from "../assets/list-icon.svg";
import CheckBox from "./Toggle-button";
import API from "./Api";
import { connect } from "react-redux";
import { error } from "jquery";
const mapStateToProps = (state) => ({
  headers: state.headers(),
});
export default connect(mapStateToProps)(
  class Service extends Component {
    data = this.props.data;
    state = {
      deletingService: false,
      is_checked: this.data.status,
    };

      componentDidUpdate(prevProps) {
      // Sync if new data comes from parent (after getDiscounts)
      if (prevProps.data !== this.props.data) {
        this.data = this.props.data;
        this.setState({
          is_checked: this.props.data.status,
        });
      }
    }

    disableService = (isActive) => {
      this.setState({ deletingService: true });

      const { code, ...restData } = this.data;

      const payload ={
        status: isActive? 1:0,
      }
      API.post(`/business/discount-codes/${this.data.id}/status`, payload, {
        headers: this.props.headers,
      })
        .then(({ data }) => {
          this.data = { ...this.data, ...data.data };
          this.setState({ is_checked: 1 });
          setTimeout(() => {
            this.setState({ is_checked: this.data.status });
          }, 100);

          window.$.notify(
            data.message,
            data.status ? "success-alert" : "error-alert"
          );
        })
        .finally(() => {
          this.setState({ deletingService: false });
        });
    };

    getTransactionText = (count) => {
      if (count === 0) {
        return "Not Used";
      } else if (count === 1) {
        return `Used ${count} time`;
      } else {
        return `Used ${count} times`;
      }
    };

    render() {
      return (
        <div className="service discount-service">
          <img src={icon} alt="" />
          <div>
            <CheckBox
              data_open={this.state.is_checked === 1}
              OnChange={(isActive) => this.disableService(isActive ? 1 : 0)}
            />
            <p className="title">{this.data.code}</p>
            <div className="service-footer discount-footer">
                <span className="discount_badge"><span>{this.data.discount_type === "automatic_discount" ? "Automatic Discount" : "Discount Code"}</span></span>
              <p className="mini-grid">
                <span>
                  {this.data.type == "flat" ? "₦" : ""}
                  {this.data.value}
                  {this.data.type == "flat" ? "" : "%"} off
                </span>
                <span className="" style={{ color: "#5D6C76" }}>
                  {this.getTransactionText(this.data.transactions_count ?? 0)}
                </span>
              </p>
                
            </div>

            <div>
              {!this.props.notEditbale ? (
                <button
                  style={{ marginLeft: "30px !important;" }}
                  onClick={() => this.props.editOnclick(this.data)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                  >
                    <path
                      d="M0 15.2501V19.0001H3.75L14.81 7.94006L11.06 4.19006L0 15.2501ZM17.71 5.04006C18.1 4.65006 18.1 4.02006 17.71 3.63006L15.37 1.29006C14.98 0.900059 14.35 0.900059 13.96 1.29006L12.13 3.12006L15.88 6.87006L17.71 5.04006Z"
                      fill="#E40587"
                    />
                  </svg>
                </button>
              ) : (
                ""
              )}
              <button
                className="delete_icon"
                onClick={() => this.props.deleteOnclick(this.data)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="19"
                  viewBox="0 0 14 19"
                  fill="none"
                >
                  <path
                    d="M1 5V17.5C1 18.3284 1.67157 19 2.5 19H11.5C12.3284 19 13 18.3284 13 17.5V5H1Z"
                    fill="#E40587"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 1.5V1C9 0.447715 8.55228 0 8 0H6C5.44772 0 5 0.447715 5 1V1.5H0.5C0.223858 1.5 0 1.72386 0 2V2.5C0 2.77614 0.223858 3 0.5 3H13.5C13.7761 3 14 2.77614 14 2.5V2C14 1.72386 13.7761 1.5 13.5 1.5H9Z"
                    fill="#E40587"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
);
